import { getBases } from '../base';
import { unrecordedFetch } from '../recorder';
import type { WhatsNewData } from './types';

/** Where the screen reads from: the service (`whatsNew.service`) or the host's own endpoint. */
export type WhatsNewSource = { service: true } | { path: string };

/**
 * `GET <base>/bugs/api/whats-new` (the service keeps the project's notes) or `GET <host base><path>` (the host serves them);
 * the widget's own request, not part of a report.
 */
export async function loadWhatsNew(source: WhatsNewSource | string): Promise<WhatsNewData> {
  const from: WhatsNewSource = typeof source === 'string' ? { path: source } : source;
  const url = 'service' in from ? `${getBases().api}/whats-new` : `${getBases().host}${from.path}`;
  let res: Response;
  try {
    res = await unrecordedFetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
  } catch {
    throw new Error('Сервер не ответил — обновите страницу.');
  }
  const data = (await res.json().catch(() => null)) as Partial<WhatsNewData> | null;
  if (!res.ok || !data || !Array.isArray(data.notes)) throw new Error(res.status === 401 ? 'Нужно войти заново.' : 'Не удалось загрузить заметки.');
  return { notes: data.notes, index: Array.isArray(data.index) ? data.index : [] };
}
